import { render, staticRenderFns } from "./addPackageForm.vue?vue&type=template&id=0e4d24f6"
import script from "./addPackageForm.vue?vue&type=script&lang=js"
export * from "./addPackageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4d24f6')) {
      api.createRecord('0e4d24f6', component.options)
    } else {
      api.reload('0e4d24f6', component.options)
    }
    module.hot.accept("./addPackageForm.vue?vue&type=template&id=0e4d24f6", function () {
      api.rerender('0e4d24f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/sku/components/addPackageForm.vue"
export default component.exports